module Meevo.Components.Controls {
    import ProductUsageAmountTypeEnum = Meevo.Model.ProductUsageAmountTypeEnum;

    export interface PartialUsageModalOptions extends Meevo.Plugins.Product.ProductInfoModalOptions {
        parentType: Meevo.Plugins.Product.ProductInfoModalParent;
        entry;
        quantityWholeList?: Meevo.Model.QuantityValueType[];
        quantityUnitsList?: Meevo.Model.QuantityValueType[];
        totalCompositeValue?: number;
        totalWhole?: number;
        totalUnits?: number;
    }

    export class PartialUsageController {
        static $inject = [
            "meevo.AppSettings",
            "$mdDialog",
            "$translate",
            "meevo.components.common.InventoryRoundingService",
            "meevo.components.modal.ModalService",
            "options"
        ];

        public calculatedUsage: number = 0;
        public decimalPrecision: number;

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            private $mdDialog: angular.material.IDialogService,
            private $translate: angular.translate.ITranslateService,
            protected roundingService: Meevo.Components.Common.IInventoryRoundingService,
            private modalService: Meevo.Components.Modal.IModalService,
            private options: PartialUsageModalOptions) {

            this.decimalPrecision = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.inventoryDecimalPrecision || 4;

        }

        $onInit() { 
            this.acceptsMultipleValues()
        }

        getProductDescription(): string {
            if (this.acceptsMultipleValues()) {
                let desc: string = `${this.options.entry.sku} : ${this.options.entry.productName}`;
                if (this.options.entry.displayName) {
                    desc += ` - ${this.options.entry.displayName}`;
                }
                return desc;
            } else {
                let desc: string = `${this.options.entry.sku} : ${this.options.entry.displayName}`;
                if (this.options.entry.variantDisplayName) {
                    desc += ` - ${this.options.entry.variantDisplayName}`;
                }
                return desc;
            }
            
        }

        getUnitOfMeasure(unitOfMeasure: Meevo.Model.UnitEnum, productUsageAmountType: Meevo.Model.ProductUsageAmountTypeEnum): string {
            switch (productUsageAmountType) {
                case Meevo.Model.ProductUsageAmountTypeEnum.PartialAmount:
                    return this.$translate.instant("ENUM_LABEL_" + unitOfMeasure);
                case Meevo.Model.ProductUsageAmountTypeEnum.WholeProduct:
                    return this.$translate.instant("LABEL_PRODUCT_USAGE_WHOLE_PRODUCT");
            }
        }

        getTotalOfNumberList(valueList: Meevo.Model.QuantityValueType[]): number {
            var total: number = 0;
            if (valueList) {
                valueList.forEach((v: Meevo.Model.QuantityValueType, ndx, arr) => { total = this.roundingService.add(total, v.quantity || 0, this.decimalPrecision); });
            }
            return total;
        }

        calculateUsage(): number {
            var totalWhole: number = this.options.totalWhole = this.getTotalOfNumberList(this.options.quantityWholeList);
            var totalUnits: number = this.options.totalUnits = this.getTotalOfNumberList(this.options.quantityUnitsList);
            let calculatedPartialUsage = ((this.options.entry.unitOfMeasureQuantity || 0) == 0) ? 0 : this.roundingService.divide(totalUnits, this.options.entry.unitOfMeasureQuantity, this.decimalPrecision);
            this.options.totalCompositeValue = this.roundingService.add(totalWhole, calculatedPartialUsage, this.decimalPrecision);
            return this.options.totalCompositeValue;
        }

        acceptsMultipleValues(): boolean {
            switch (this.options.parentType) {
                case Meevo.Plugins.Product.ProductInfoModalParent.InventoryCount:
                    return true;

                case Meevo.Plugins.Product.ProductInfoModalParent.EmployeeSupplyUsage:
                default:
                    return false;
            }
        }

        onUnitInputsChange(newQuantity, index, usageType: ProductUsageAmountTypeEnum) {
          switch (usageType) {
            case ProductUsageAmountTypeEnum.WholeProduct:
                this.options.quantityWholeList[index].quantity = newQuantity;
                break;

            case ProductUsageAmountTypeEnum.PartialAmount:
                this.options.quantityUnitsList[index].quantity = newQuantity;
                break;
        
            default:
                break;
        }

          this.calculateUsage()
        }

        addLineItem(usageType: ProductUsageAmountTypeEnum) {
            switch (usageType) {
                case ProductUsageAmountTypeEnum.WholeProduct:
                    this.options.quantityWholeList && this.options.quantityWholeList.push({quantity: 0})
                    break;
    
                case ProductUsageAmountTypeEnum.PartialAmount:
                    this.options.quantityUnitsList && this.options.quantityUnitsList.push({quantity: 0})
                    break;
            
                default:
                    break;
            }
        }

        deleteLineItem(usageType: ProductUsageAmountTypeEnum, index) {
            switch (usageType) {
                case ProductUsageAmountTypeEnum.WholeProduct:
                    if (index > 0) {
                        this.options.quantityWholeList && this.options.quantityWholeList.splice(index, 1)
                    } else {
                        this.options.quantityWholeList[index].quantity = 0;
                    };
                    break;

                case ProductUsageAmountTypeEnum.PartialAmount:
                    if (index > 0) {
                        this.options.quantityUnitsList && this.options.quantityUnitsList.splice(index, 1)
                    } else {
                        this.options.quantityUnitsList[index].quantity = 0;
                    };

                    break;

                default:
                    break;
            }
        }

        closeModal(e): void {
            if (e) e.stopPropagation();
            this.$mdDialog.hide(false);
        }

        applyChanges(e): void {
            if (e) e.stopPropagation();
            this.$mdDialog.hide(true);
        }
    }

    angular.module("meevo.components.controls")
        .controller("meevo.components.controls.productPartialUsage.PartialUsageController", PartialUsageController);
}